import React, { useEffect, useState, useRef } from "react";
import { checkInput, getDataFromRoutes, setMetaTags } from "../../utils/util_functions";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import eye from "../../images/eye.svg";
import { getDeleteMeForm, getRoutes, getUser } from "../../services/selectors";
import { DELETE_ME_EDIT_CP } from "../../services/actions/delete_me_actions";
import { deleteMeThunk } from "../../services/actions/delete_me_actions";
import { getCookie } from "../../utils/cookie";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { USER_ROLES } from "../../utils/constants";


const DeleteMe = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [statusCurrPassword, setStatusCurrPassword] = useState({});

  const [formValid, setFormValid] = useState(false);

  const refToCPInput = useRef(null);

  const {
    current_password
  } = useSelector(getDeleteMeForm);

  const user = useSelector(getUser);

  useEffect(() => { window.scrollTo({ top: 0, left: 0 }) }, []);

  const routes = useSelector(getRoutes);
  const location = useLocation();

  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    const {
      metaTitle, metaDescription, metaKeywords, metaRobots
    } = getDataFromRoutes(location.pathname, routes);
    setMetaTags(
      metaTitle, metaDescription,
      metaKeywords, metaRobots
    )
    // eslint-disable-next-line
  }, [])

  const changeCurrPassword = (e) => {
    if (e.target.value.length > 64) {
      e.target.value = e.target.value.slice(0, 64);
    }
    const currStatus = checkInput(e.target.value, 8, 64, 'password');
    setStatusCurrPassword({ ...statusCurrPassword, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: DELETE_ME_EDIT_CP, current_password: e.target.value });
  }

  const changeVisibilityCP = () => {
    refToCPInput.current.type === 'password' ?
      refToCPInput.current.type = 'string' :
      refToCPInput.current.type = 'password';
  }

  useEffect(() => {
    const validCurrPassword = checkInput(current_password, 8, 64, 'password').valid;

    setFormValid(validCurrPassword);
  }, [current_password,]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      current_password
    }
    if (user.role === USER_ROLES.customer) {
      dispatch(
        deleteMeThunk(
          getCookie('accessToken'), getCookie('refreshToken'),
          navigate, data
        )
      );
    }
  }


  return (
    <form onSubmit={handleSubmit} className="form" noValidate>

      <label htmlFor="current_password" className="label_text">
        Существующий пароль <span style={{ color: 'red' }}>*</span>
        <input
          type="password"
          id="current_password" name="current_password"
          required={true}
          value={current_password || ''}
          onChange={changeCurrPassword}
          className="input input__password"
          ref={refToCPInput}
        />
        <img src={eye} className="eye"
          alt='visibility current password' onClick={changeVisibilityCP}
        />
        <p className="error">{statusCurrPassword?.text}</p>
      </label>
      <button type="submit"
        className={`button button__red ${!formValid ? 'button__red_disabled' : ''}`}
        disabled={!formValid}
      >
        Удалить аккаунт
      </button>
    </form>
  );
};

export default DeleteMe;
